import _ from 'lodash';

import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Loading from 'components/Loading/Loading';

import { fetchDispute, respondToDispute } from '../../../../actions/Admin/disputeActions';
import IssueDetails from '../../IssueDetails';

import './style.css';

class ManageDisputes extends Component {
  constructor() {
    super();
    this.state = {
      resolutionDescription: ''
    };
  }

  componentWillMount() {
    let offset = 0;
    if (this.props.location.query.offset) {
      offset = parseInt(this.props.location.query.offset, 10);
    }
    this.props.fetchDispute(offset);
  }

  fetchNextDispute = (e, path) => {
    e.preventDefault();
    browserHistory.replace(path);
    this.props.fetchDispute(this.props.dispute.dispute.offset + 1);
  }

  fetchPreviousDispute = (e, path) => {
    e.preventDefault();
    browserHistory.replace(path);
    this.props.fetchDispute(this.props.dispute.dispute.offset - 1);
  }

  validateResolution = () => {
    if (this.state.resolutionDescription.length < 10) {
      alert('You must provide a resolution description');
      return false;
    }
    return true;
  }

  approve = (issueId) => {
    if (this.validateResolution()) {
      this.props.respondToDispute(issueId, this.state.resolutionDescription, 1);
    }
  }

  deny = (issueId) => {
    if (this.validateResolution()) {
      this.props.respondToDispute(issueId, this.state.resolutionDescription, 0);
    }
  }

  handleResolutionChange = (e) => {
    this.setState({ resolutionDescription: e.target.value });
  }

  isSubmitDisabled = () => {
    return this.props.dispute.status === 'SUBMITTING';
  }

  hasIssueNavigation = () => {
    return this.props.dispute.dispute && this.props.dispute.dispute.total;
  };

  renderIssueNavigation() {
    const { offset, total } = this.props.dispute.dispute;

    return (
      <nav>
        <div className="nav-left">
          {offset > 0 && (
            <a
              href={`/admin?offset=${offset - 1}`}
              onClick={e => this.fetchPreviousDispute(e, `/admin?offset=${offset - 1}`)}
            >
              &laquo; Previous
            </a>
          )}
        </div>
        <div className="nav-center">
          Issue {offset + 1}/{total}
        </div>
        <div className="nav-right">
          {offset < total - 1 && (
            <a
              href={`/admin?offset=${offset + 1}`}
              onClick={e => this.fetchNextDispute(e, `/admin?offset=${offset + 1}`)}
            >
              Next &raquo;
            </a>
          )}
        </div>
      </nav>
    );
  }

  render() {
    if (this.props.dispute.status === 'SUBMITTED') {
      this.setState({ resolutionDescription: '' });
      this.props.fetchDispute();
    }

    const disputedIssue = _.get(this.props.dispute, 'dispute.data', null);
    const showForm =
      disputedIssue &&
      (this.props.dispute.status === 'SUCCESS' ||
        this.props.dispute.status === 'SUBMITTED' ||
        this.props.dispute.status === 'SUBMIT_FAILED');

    return (
      <div className="ManageDisputes">
        <div className="col-auto">
          {this.hasIssueNavigation() && (
            <div className="row">{this.renderIssueNavigation()}</div>
          )}

          <div className="row mb-2">
            <div className="card">
              {(this.props.dispute.status === 'LOADING' ||
                this.props.dispute.status === null ||
                this.props.dispute.status === 'SUBMITTING') && (
                <div className="loading">
                  <Loading />
                </div>
              )}

              {showForm && (
                <div>
                  <IssueDetails
                    appointment={disputedIssue.appointment}
                    issue={disputedIssue}
                    resolutionDescription={this.state.resolutionDescription}
                    handleResolutionChange={this.handleResolutionChange}
                    approve={this.approve}
                    deny={this.deny}
                    isSubmitDisabled={this.isSubmitDisabled}
                  />
                  {this.props.dispute.status === 'SUBMIT_FAILED' && (
                    <div className="mt-2">Problem submitting</div>
                  )}
                </div>
              )}

              {this.props.dispute.status === 'SUCCESS' && disputedIssue === null && (
                <div className="issue-title mt-4">There are no more disputes to process</div>
              )}

              {this.props.dispute.status === 'FAIL' && <div>Problem</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dispute: state.dispute
  };
}

export default connect(mapStateToProps, { fetchDispute, respondToDispute })(ManageDisputes);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/ManageDisputes/index.js